export const noteCard = {
  deleteText: 'Sind Sie sicher, dass Sie diese Notiz löschen wollen?',
  deleteModalButtonText: 'Löschen',
  notePlaceholder: 'Notiz',
  updateModalButtonText: 'Anpassen',
  updateModalTitle: 'Notiz bearbeiten',
  updateErrorToastText: 'Ihre Notiz konnte nicht bearbeitet werden.',
  deleteErrorToastText: 'Ihre Notiz konnte nicht gelöscht werden.',
}
